import { useState, useEffect } from "react"
import {Clock} from 'lucide-react'

export default function StickyBottomBar() {
  const [timeLeft, setTimeLeft] = useState({ days: 2, hours: 14, minutes: 12 })

  useEffect(() => {
    const target = new Date(Date.now() + (2 * 24 + 14) * 60 * 60 * 1000 + 12 * 60 * 1000)
    const interval = setInterval(() => {
      const now = Date.now()
      const diff = target.getTime() - now
      if (diff <= 0) {
        clearInterval(interval)
        return
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t-2 border-red-500 shadow-2xl px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-1.5 text-red-600 text-sm font-semibold">
          <Clock className="w-4 h-4" />
          <span>
            Oferta termina em {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m
          </span>
        </div>
        <a
          href="#cta-final"
          onClick={(e) => { e.preventDefault(); document.getElementById('cta-final')?.scrollIntoView({ behavior: 'smooth' }); }}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold text-sm px-5 py-2.5 rounded-lg shadow-md transition-all whitespace-nowrap cursor-pointer"
        >
          Quero minha vaga &rarr;
        </a>
      </div>
    </div>
  )
}
